import { LearnersReliefListingsReliefListingIndex } from "@/types/serializers"
import { useProps } from "@/lib/page-rendering"

export type IndexProps = {
  relief_listings: Array<LearnersReliefListingsReliefListingIndex>
}
export const useIndexProps = () => useProps<IndexProps>()
